import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { TrashIcon } from '@heroicons/react/24/outline';

export default function DeleteButton({ onDelete }) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const anchorRef = useRef(null);
  const [popoverPos, setPopoverPos] = useState({ top: -9999, left: -9999 });

  useLayoutEffect(() => {
    if (!confirmOpen) return;
    const update = () => {
      const el = anchorRef.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      setPopoverPos({ top: Math.round(r.bottom + 8), left: Math.round(r.left) });
    };
    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update, true);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update, true);
    };
  }, [confirmOpen]);
  return (
    <>
      <button
        type="button"
        data-role="control-button delete-btn"
        ref={anchorRef}
        onPointerDownCapture={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true;
        }}
        onPointerDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof window !== 'undefined') {
            window.__sbwSuppressCanvasClick = true;
          }
        }}
        onMouseDownCapture={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true;
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof window !== 'undefined') {
            window.__sbwSuppressCanvasClick = true;
          }
        }}
        onClickCapture={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true;
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof window !== 'undefined') {
            window.__sbwSuppressCanvasClick = true;
          }
          setConfirmOpen(true);
        }}
        onPointerUp={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true;
          setConfirmOpen(true);
        }}
        style={{ zIndex: 1000, pointerEvents: 'auto', cursor: 'pointer' }}
        className="absolute -top-1 right-0 translate-x-1/2 p-2 bg-white rounded-full shadow-lg ring-2 ring-indigo-500 hover:bg-white"
        title="Delete element"
      >
        <TrashIcon className="h-5 w-5 text-gray-500 hover:text-red-500" />
      </button>

      {confirmOpen && createPortal(
        <div
          data-role="control-button"
          onMouseDownCapture={(e) => { e.preventDefault(); e.stopPropagation(); if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true; }}
          onClickCapture={(e) => { e.preventDefault(); e.stopPropagation(); if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true; }}
          className="bg-white border rounded shadow-lg p-2"
          style={{ position: 'fixed', top: popoverPos.top, left: popoverPos.left, zIndex: 2000, pointerEvents: 'auto' }}
        >
          <div className="text-xs mb-2">Delete this element?</div>
          <div className="flex space-x-2">
            <button
              type="button"
              className="px-2 py-1 text-xs text-white bg-red-600 rounded hover:bg-red-700"
              onPointerDownCapture={(e) => { e.preventDefault(); e.stopPropagation(); if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true; }}
              onPointerUp={(e) => { e.preventDefault(); e.stopPropagation(); if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true; onDelete?.(); setConfirmOpen(false); }}
              onClickCapture={(e) => { e.preventDefault(); e.stopPropagation(); if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true; }}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); onDelete?.(); setConfirmOpen(false); }}
            >
              Delete
            </button>
            <button
              type="button"
              className="px-2 py-1 text-xs text-gray-700 bg-gray-100 rounded hover:bg-gray-200"
              onPointerDownCapture={(e) => { e.preventDefault(); e.stopPropagation(); if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true; }}
              onPointerDown={(e) => { e.preventDefault(); e.stopPropagation(); setConfirmOpen(false); }}
              onPointerUp={(e) => { e.preventDefault(); e.stopPropagation(); if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true; setConfirmOpen(false); }}
              onClickCapture={(e) => { e.preventDefault(); e.stopPropagation(); if (typeof window !== 'undefined') window.__sbwSuppressCanvasClick = true; }}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); setConfirmOpen(false); }}
              onMouseDownCapture={(e) => { e.preventDefault(); e.stopPropagation(); }}
              onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setConfirmOpen(false); }}
              onMouseUp={(e) => { e.preventDefault(); e.stopPropagation(); setConfirmOpen(false); }}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); setConfirmOpen(false); } }}
            >
              Cancel
            </button>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
